import React from "react";
import styled from "styled-components";

const LogoSvg = styled.svg<{ $size: number }>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  display: inline-block;
`;

export function Logo({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <LogoSvg
      $size={size}
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Main background circle */}
      <circle cx="50" cy="50" r="48" fill="#4b5563" stroke="#1f2937" strokeWidth="2" />

      {/* Central large gear */}
      <g transform="translate(50, 50)">
        {/* Gear teeth - 8 teeth around the circle */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
          <rect
            key={i}
            x="-3"
            y="-22"
            width="6"
            height="6"
            fill="#e5e7eb"
            transform={`rotate(${angle})`}
          />
        ))}

        {/* Main gear body */}
        <circle cx="0" cy="0" r="16" fill="#9ca3af" stroke="#1f2937" strokeWidth="1.5" />

        {/* Inner circle detail */}
        <circle cx="0" cy="0" r="8" fill="#4b5563" stroke="#1f2937" strokeWidth="1" />

        {/* Center hole */}
        <circle cx="0" cy="0" r="4" fill="#1f2937" />
      </g>

      {/* Smaller gear top-right - interlocking */}
      <g transform="translate(70, 30)">
        {/* Small gear teeth - 6 teeth */}
        {[0, 60, 120, 180, 240, 300].map((angle, i) => (
          <rect
            key={i}
            x="-2"
            y="-13"
            width="4"
            height="4"
            fill="#fecaca"
            transform={`rotate(${angle})`}
          />
        ))}

        {/* Small gear body */}
        <circle cx="0" cy="0" r="10" fill="#c1121f" stroke="#7f1d1d" strokeWidth="1.2" />

        {/* Inner detail */}
        <circle cx="0" cy="0" r="5" fill="#991b1b" stroke="#7f1d1d" strokeWidth="0.8" />

        {/* Center hole */}
        <circle cx="0" cy="0" r="2.5" fill="#7f1d1d" />
      </g>

      {/* Smaller gear bottom-left - interlocking */}
      <g transform="translate(30, 70)">
        {/* Small gear teeth - 6 teeth */}
        {[0, 60, 120, 180, 240, 300].map((angle, i) => (
          <rect
            key={i}
            x="-2"
            y="-13"
            width="4"
            height="4"
            fill="#fed7aa"
            transform={`rotate(${angle})`}
          />
        ))}

        {/* Small gear body */}
        <circle cx="0" cy="0" r="10" fill="#f97316" stroke="#c2410c" strokeWidth="1.2" />

        {/* Inner detail */}
        <circle cx="0" cy="0" r="5" fill="#ea580c" stroke="#c2410c" strokeWidth="0.8" />

        {/* Center hole */}
        <circle cx="0" cy="0" r="2.5" fill="#c2410c" />
      </g>

      {/* "OH-NO!" text indicator - stylized warning symbol */}
      <g transform="translate(50, 50)">
        {/* Small warning triangle in center */}
        <polygon
          points="0,-3 2.6,1.5 -2.6,1.5"
          fill="#fbbf24"
          stroke="#78350f"
          strokeWidth="0.5"
        />
        <circle cx="0" cy="0.5" r="0.5" fill="#78350f" />
      </g>
    </LogoSvg>
  );
}
